module.exports = __webpack_public_path__ + "static/img/protoboard_400-1.1cf022f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/protoboard_400-1.svg
// module id = rryp
// module chunks = 0